import { MutationTree } from 'vuex';
import ILocalState from './stateInterface';

const mutations: MutationTree<ILocalState> = {
    setColors(state, colors: any[]) {
        state.colors = colors;
    },
    setPowders(state, powders: any[]) {
        state.powders = powders;
    },
    setPrices(state, prices: any[]) {
        state.prices = prices;
    },
    setSurfaces(state, surfaces: any[]) {
        state.surfaces = surfaces;
    },
    setQualities(state, qualities: any[]) {
        state.qualities = qualities;
    },
    setGlosses(state, glosses: any[]) {
        state.glosses = glosses;
    },
    setEffects(state, effects: any[]) {
        state.effects = effects;
    },
    setCharts(state, charts: any[]) {
        state.charts = charts;
    },
    setCollections(state, collections: any[]) {
        state.collections = collections;
    },
    setLatestColors(state, latestColors: any[]) {
        state.latestColors = latestColors;
    },
};

export default mutations;
